import { render, staticRenderFns } from "./Aplicativo.vue?vue&type=template&id=a09dfb84&"
import script from "./Aplicativo.vue?vue&type=script&lang=js&"
export * from "./Aplicativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports